import Http from '../Http';
import { LARAVEL_BACKEND_API_URL } from '../Helper';

export function getGuidelines(params) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            // Build the query string from the params object
            const queryParams = new URLSearchParams(params).toString();
            const url = `${LARAVEL_BACKEND_API_URL}v1/installation-guidelines?${queryParams}`;

            Http.get(url)
                .then((res) => {
                    if (res.data.status === 'success') {
                        return resolve(res.data.data);
                    } else {
                        return reject(res.data.message);
                    }
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}

export  function postGuidelines(formData){
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.post(LARAVEL_BACKEND_API_URL + 'v1/installation-guidelines', formData)
                .then((res) => {
                    return resolve(res.data);
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}

export  function updateGuidelines(id,formData){
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.post(LARAVEL_BACKEND_API_URL + `v1/installation-guidelines/${id}`, formData)
                .then((res) => {
                    return resolve(res.data);
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}
export  function DeleteGuidelines(id,formData){
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.delete(LARAVEL_BACKEND_API_URL + `v1/installation-guidelines/${id}`)
                .then((res) => {
                    return resolve(res.data);
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}

export function getManufacturer() {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.get(LARAVEL_BACKEND_API_URL + 'v1/installation-guidelines/manufacturers' )
                .then((res) => {
                    return resolve(res.data.data);
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}

export function getStyles(manufacturer) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            // Check if manufacturer is provided
            if (!manufacturer || !manufacturer.manufacturer) {
                return reject(new Error("Manufacturer is required."));
            }

            // Construct the API URL with the manufacturer as a query parameter
            const manufacturerValue = manufacturer.manufacturer;
            const url = `${LARAVEL_BACKEND_API_URL}v1/installation-guidelines/styles?manufacturer=${encodeURIComponent(manufacturerValue)}`;

            Http.get(url)
                .then((res) => {
                    if (res.data.status === 'success') {
                        return resolve(res.data.data);
                    } else {
                        return reject(res.data.message);
                    }
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}
 
export function getYears(params) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            if (!params || !params.manufacturer) {
                return reject(new Error("Manufacturer is required."));
            }

            const queryParams = new URLSearchParams({
                manufacturer: params.manufacturer,
                ...(params.style && { style: params.style })
            }).toString();

            const url = `${LARAVEL_BACKEND_API_URL}v1/installation-guidelines/years?${queryParams}`;

            Http.get(url)
                .then((res) => {
                    if (res.data.status === 'success') {
                        return resolve(res.data.data);
                    } else {
                        return reject(res.data.message);
                    }
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}
